export { default } from './TimeQuizStep';
